// extracted by css-extract-rspack-plugin
export default {"cls1":"ScrollableTabNav-wjs-cls1_MrL","cls2":"ScrollableTabNav-wjs-cls2_17x ScrollableTabNav-wjs-cls1_MrL"};